import React, { PropsWithChildren } from 'react'

import { IProps } from './IProps'
import { ParagraphText } from './style'

export const BodyText = (props: PropsWithChildren<IProps>) => {
  return (
    <ParagraphText
      textAlign={props.textAlign}
      headingLevel={props.headingLevel}
      fontColor={props.color}
      fontStyle={props.fontStyle}
      style={props.style}>
      {props.children}
    </ParagraphText>
  )
}
